import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import CoreTypography from '../../CoreTypography';
import OTPInput from '../../OTPInput';
import { useStyles } from './styles';
export default ({ onCodeEntered }) => {
    const { classes } = useStyles();
    const [otpCode, setOtpCode] = useState('');
    const [isCodeError, setIsCodeError] = useState(false);
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    useEffect(() => {
        setIsCodeError(false);
        if (otpCode.length != 6)
            return;
        onCodeEntered(otpCode, isSuccess => setIsCodeError(!isSuccess));
    }, [otpCode]);
    return (_jsxs(_Fragment, { children: [_jsx(OTPInput, { onChange: setOtpCode, size: isMobile ? 'small' : 'medium' }), isCodeError && (_jsx(CoreTypography, Object.assign({ variant: 'bodySm', className: classes.InputErrorMessage }, { children: "This code was incorrect. Please try again." })))] }));
};
//# sourceMappingURL=index.js.map